import { login } from '@/api/system/auth'
import { getMyInfo } from '@/api/system/user'
import { getToken, removeToken, setToken } from '@/utils/auth'
import { defineStore } from 'pinia'
import { tagsViewStore } from './tagsView'

export const userStore = defineStore('user', {
  state: () => {
    return {
      token: getToken(),
      profile: null as AppUserProfile | null,
      roles: [] as AppRole[],
      actions: [] as AppUserAction[],
      unreadMessages: 0,
      menus: [] as AppMenu[]
    }
  },
  actions: {
    login(userInfo: AppUserType) {
      const { username, password, captchaId, captchaCode } = userInfo
      return new Promise((resolve, reject) => {
        login({
          username: username.trim(),
          password: password,
          captchaId: captchaId,
          captchaCode: captchaCode
        }).then(response => {
          const { data } = response
          const accessToken = data.accessToken
          this.token = accessToken
          setToken(accessToken)
          resolve(true)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getMyInfo(): Promise<AppUserProfile> {
      return new Promise((resolve, reject) => {
        getMyInfo().then(response => {
          const { data } = response
          if (!data) {
            reject('用户信息请求失败，请尝试重新登录')
          }
          const { roles, menus, actions, unreadMessages } = data
          this.roles = roles
          this.menus = menus
          this.actions = actions
          this.profile = data
          this.unreadMessages = unreadMessages
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    logout() {
      return new Promise(resolve => {
        this.token = ''
        this.roles = []
        this.menus = []
        this.actions = []
        this.unreadMessages = 0
        this.profile = null
        removeToken()
        // resetRouter()

        // dispatch('tagsView/delAllViews', null, { root: true })
        tagsViewStore().delAllViews()
        resolve(true)
      })
    },
    resetToken() {
      return new Promise(resolve => {
        this.token = ''
        this.roles = []
        removeToken()
        resolve(true)
      })
    },
    setUnreadMessages(unreadMessages: number) {
      this.unreadMessages = unreadMessages
    },
    updateMyProfile(profile: any) {
      this.profile = { ...this.profile, ...profile }
    }
  }
})